const cartDrawer = document.querySelector("c-drawer[data-component-id='cart-drawer']");
if (!cartDrawer) return;

// Function to handle the toggle action
async function handleMembershipToggle(e) {
    const membershipToggle = e.target.closest('#club-membership-toggle');
    if (!membershipToggle) return;
    const wantsMembership = membershipToggle.checked;
    sessionStorage.setItem('wants_become_club_member', wantsMembership ? 'true' : 'false');

    try {
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    "wants_become_club_member": wantsMembership ? 'true' : 'false'
                }
            })
        });

        const data = await response.json();

        // Dispatch event after successful update
        const event = new CustomEvent('member-updated__from-toggle');
        document.dispatchEvent(event);
    } catch (error) {
        console.error('Error:', error);
    }


}

cartDrawer.addEventListener('change', (e) => handleMembershipToggle(e));
